import { render, staticRenderFns } from "./BackupsCliente.vue?vue&type=template&id=03f70108&"
import script from "./BackupsCliente.vue?vue&type=script&lang=js&"
export * from "./BackupsCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports